
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-f6b0c17ba1";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$BASE_URL = "https://www.atlassian.com";
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${$b6785f1d81c92020$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("lfqXN", function(module, exports) {
$parcel$export(module.exports, "TryPage", function () { return $75831ec207552eea$export$609689a2a01efdbc; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("axzLb");
var $blNyO = parcelRequire("blNyO");
const $75831ec207552eea$export$609689a2a01efdbc = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $blNyO.TryPageTemplate), {});

});
parcelRegister("axzLb", function(module, exports) {
$parcel$export(module.exports, "TryPageTemplate", function () { return (parcelRequire("blNyO")).TryPageTemplate; });

var $blNyO = parcelRequire("blNyO");

});
parcelRegister("blNyO", function(module, exports) {
$parcel$export(module.exports, "TryPageTemplate", function () { return $6b6ef2c343dd8dd5$export$86c5cc40b74df40f; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $ea4mV = parcelRequire("ea4mV");

var $axrSA = parcelRequire("axrSA");

var $km4VI = parcelRequire("km4VI");

var $fPSzg = parcelRequire("fPSzg");

var $gTqUW = parcelRequire("gTqUW");

var $aUlfh = parcelRequire("aUlfh");

var $eLUM2 = parcelRequire("eLUM2");

var $liucL = parcelRequire("liucL");

var $cBRR6 = parcelRequire("cBRR6");
const $6b6ef2c343dd8dd5$export$86c5cc40b74df40f = ()=>{
    const [dxpMigrationExposureFired, fireDxpMigrationExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationSoftwarePage);
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationExposureFired) fireDxpMigrationExposure();
    }, [
        dxpMigrationExposureFired,
        fireDxpMigrationExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                    isShowTryNowLink: false,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "try"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aUlfh.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $liucL.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cBRR6.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $km4VI.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $axrSA.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eLUM2.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gTqUW.default), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fPSzg.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("axrSA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9dc8f62f5e147b0$export$2e2bcd8739ae039; });
/* code-build-ship-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $e9dc8f62f5e147b0$var$sectionCss = null;
const $e9dc8f62f5e147b0$var$CodeBuildShipSection = ()=>{
    const intl = (0, $8e22h.default)();
    const codeBuildShipHeaderText = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.headerText",
        defaultMessage: "Code, Build, & Ship"
    });
    const bitbucketBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.bitbucket.bodyText",
        defaultMessage: "Collaborate on code with inline comments and pull requests. Manage and share your Git repositories to build and ship software, as a team."
    });
    const sourcetreeBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.sourcetree.bodyText",
        defaultMessage: "Harness the full power of Git and Mercurial in a beautifully simple application. Get the free desktop client for Mac and Windows."
    });
    const compassBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.compass.bodyText",
        defaultMessage: "Bring your distributed software architecture and the teams that collaborate on it together in a single, unified place."
    });
    const rovoDevBody = intl.formatMessage({
        id: "TryPageTemplate.codeBuildShip.rovoDev.bodyText",
        defaultMessage: "Stay in the flow longer with AI-enabled productivity and quality for the full software delivery lifecycle."
    });
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const downloadNow = intl.formatMessage((0, $8p9Sp.messages).downloadNow);
    const bitbucketLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    });
    const rovoLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "rovodev",
        type: "logo",
        appearance: "brand"
    });
    const sourcetreeLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "sourcetree",
        type: "logo",
        appearance: "brand"
    });
    const compassLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "code-build-ship",
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                    dividerColor: "#ff8b00",
                    headerText: codeBuildShipHeaderText
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: bitbucketLogo,
                        link: (0, $kooLp.useLocalizedHref)("/software/bitbucket/bundle"),
                        bodyText: bitbucketBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: rovoLogo,
                        link: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=devai"),
                        bodyText: rovoDevBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: sourcetreeLogo,
                        link: "https://www.sourcetreeapp.com/",
                        bodyText: sourcetreeBody,
                        ctaText: downloadNow
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: compassLogo,
                        link: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=compass"),
                        bodyText: compassBody,
                        ctaText: tryCloud
                    })
                ]
            })
        ]
    });
};
var $e9dc8f62f5e147b0$export$2e2bcd8739ae039 = $e9dc8f62f5e147b0$var$CodeBuildShipSection;

});
parcelRegister("k8C2X", function(module, exports) {
$parcel$export(module.exports, "TryPageCard", function () { return (parcelRequire("lVutU")).TryPageCard; });
$parcel$export(module.exports, "TryPageHeader", function () { return (parcelRequire("5Dppx")).TryPageHeader; });

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

});
parcelRegister("lVutU", function(module, exports) {
$parcel$export(module.exports, "TryPageCard", function () { return $94c5ed983b086607$export$78a2651bc04a8175; });
/* try-page-card.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $fJP6M = parcelRequire("fJP6M");
const $94c5ed983b086607$var$pStyle = null;
const $94c5ed983b086607$var$tryPageCardStyles = null;
const $94c5ed983b086607$var$logoBlockStyles = null;
const $94c5ed983b086607$var$StyledLogo = (logo)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1752zwfg _w8l51wug _4x201osq"
        ]),
        children: logo
    });
};
const $94c5ed983b086607$export$78a2651bc04a8175 = (props)=>{
    const { title: title, logo: logo, link: link, bodyText: bodyText, ctaText: ctaText, buttonColor: buttonColor, buttonType: buttonType } = props;
    const styledLogo = logo && $94c5ed983b086607$var$StyledLogo(logo);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                children: title
            }),
            styledLogo && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                href: link,
                children: styledLogo
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1wyb1j6v _1pfhgrf3 _6rth1tcg",
                    "tryCardText"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.Button), {
                className: "ctaButton",
                text: ctaText,
                type: buttonType !== null && buttonType !== void 0 ? buttonType : "secondary",
                url: link,
                size: "small",
                color: buttonColor !== null && buttonColor !== void 0 ? buttonColor : "darkblue",
                dataEventProps: {
                    "data-product-key": "try",
                    "data-event-component": "linkButton",
                    "data-event-container": "cardSection",
                    "data-event": "clicked",
                    "data-label": ctaText
                }
            })
        ]
    });
};

});

parcelRegister("5Dppx", function(module, exports) {
$parcel$export(module.exports, "TryPageHeader", function () { return $1e078ab4da7fc99d$export$d30aca31b48239d; });
/* try-page-header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $2tb46 = parcelRequire("2tb46");
const $1e078ab4da7fc99d$export$d30aca31b48239d = (props)=>{
    const { dividerColor: dividerColor, headerText: headerText } = props;
    const headerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4f1d1bqd _z5uk7vkz _1boa7vkz _16itidpf _ad5cidpf _4rmj11ph _16niidpf _1132idpf _19abftgi _edooidpf _rzyb1k8s _1apkdlk8 _1x4qahaf _hkvxdlk8 _sizi1tcg _11o6bmm0 _u25g1y44 _19ed7vkz _pgbz11ux _2z90idpf _1mvaidpf"
        ]),
        style: {
            "--_ei0dq9": (0, $6ZVlx.default)(dividerColor)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
            headerText: headerText,
            headerType: "h2",
            horizontalRule: true
        })
    });
};

});


parcelRegister("8p9Sp", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $2356406d4679fc86$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $2356406d4679fc86$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    tryCloud: {
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    },
    downloadNow: {
        id: "TryPageTemplate.downloadNow",
        defaultMessage: "Download now"
    }
});

});


parcelRegister("km4VI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $820dda0b0a60c7c4$export$2e2bcd8739ae039; });
/* collaborate-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $820dda0b0a60c7c4$var$sectionCss = null;
const $820dda0b0a60c7c4$var$CollaborateSection = ()=>{
    const intl = (0, $8e22h.default)();
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const collaborateTitle = intl.formatMessage({
        id: "TryPageTemplate.collaborate.title",
        defaultMessage: "Collaborate"
    });
    const confluenceBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.confluenceBody",
        defaultMessage: "Get things done instead of hunting things down. Organize your work, create documents, and discuss everything in one place."
    });
    const trelloBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.trelloBody",
        defaultMessage: "Collaborate and get more done. Trello boards enable your team to organize projects in a fun, flexible, and visual way."
    });
    const loomBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.loomBody",
        defaultMessage: "Record your screen, camera, and voice with Loom. Send async video messages on an AI-powered platform."
    });
    const confluenceLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "confluence",
        type: "logo",
        appearance: "brand"
    });
    const trelloLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "trello",
        type: "logo",
        appearance: "brand"
    });
    const loomLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "loom",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "collaborateCards",
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                    headerText: collaborateTitle,
                    dividerColor: (0, $kbpa7.wacToken)("color.primary.blue")
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: confluenceLogo,
                        link: (0, $kooLp.useLocalizedHref)("/software/confluence/free"),
                        bodyText: confluenceBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: trelloLogo,
                        link: "https://www.trello.com/signup",
                        bodyText: trelloBody,
                        ctaText: tryCloud
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {}),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                        logo: loomLogo,
                        link: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium"),
                        bodyText: loomBody,
                        ctaText: tryCloud
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
                ]
            })
        ]
    });
};
var $820dda0b0a60c7c4$export$2e2bcd8739ae039 = $820dda0b0a60c7c4$var$CollaborateSection;

});

parcelRegister("fPSzg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da7b5b800f10f760$export$2e2bcd8739ae039; });
/* enterprise-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $2tb46 = parcelRequire("2tb46");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
const $da7b5b800f10f760$var$sectionCss = null;
const $da7b5b800f10f760$var$headerStyle = null;
const $da7b5b800f10f760$var$lowerCss = null;
const $da7b5b800f10f760$var$imageCss = null;
const $da7b5b800f10f760$var$EnterpriseSection = ()=>{
    const intl = (0, $8e22h.default)();
    const goBigHeader = intl.formatMessage({
        id: "try.enterprise.goBig",
        defaultMessage: "Go big with Atlassian Enterprise"
    });
    const goBigBody = intl.formatMessage({
        id: "try.enterprise.goBigBody",
        defaultMessage: "Connect, accelerate, and scale your entire enterprise with Atlassian enterprise solutions."
    });
    const learnMore = intl.formatMessage({
        id: "try.enterprise.learnMore",
        defaultMessage: "Learn more"
    });
    const cloud = intl.formatMessage({
        id: "try.enterprise.cloud",
        defaultMessage: "Cloud"
    });
    const cloudBody = intl.formatMessage({
        id: "try.enterprise.cloudBody",
        defaultMessage: "Atlassian cloud solutions are equipped with everything large and growing teams need to scale collaboration and workflows seamlessly."
    });
    const dataCenter = intl.formatMessage({
        id: "try.enterprise.dataCenter",
        defaultMessage: "Data Center"
    });
    const dataCenterBody = intl.formatMessage({
        id: "try.enterprise.dataCenterBody",
        defaultMessage: "Host our applications with IaaS vendors like AWS or Azure. Data Center is our self-managed solution for advanced administration at scale."
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_syazcd5j _bfhk1ep1 _ca0q12bs _u5f3idpf _n3td12bs _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_l5k1bfng _11ebahaf _2fhk4jg8 _bpspbfng _1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                        headerText: goBigHeader,
                        headerType: "h2",
                        isCentered: true,
                        bodyText: goBigBody,
                        ctaProps: {
                            buttonProps: {
                                className: "ctaButton",
                                text: learnMore,
                                url: "https://www.atlassian.com/enterprise",
                                type: "primary",
                                color: "lightblue",
                                size: "small"
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1r2tidpf _1h3oud5o _hrxpidpf _oqlkud5o _3fwinqt0 _x3mzbfng _k48p4jg8 _1o6v1j6v _ggmh1k8s _r8nt4jg8 _1adi12sy _19tboxwj _43ds1ep1 _bna711ux"
                ]),
                style: {
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                            title: cloud,
                            link: (0, $kooLp.useLocalizedHref)("/enterprise/cloud"),
                            bodyText: cloudBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
                            title: dataCenter,
                            link: (0, $kooLp.useLocalizedHref)("/enterprise/data-center"),
                            bodyText: dataCenterBody,
                            ctaText: learnMore,
                            buttonColor: "lightblue",
                            buttonType: "primary"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _1bah1h6o _4cvr1h6o _1e0c1txw"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/database-server-on-v3.webp",
                                    alt: intl.formatMessage({
                                        id: "try.enterprise.databaseServer",
                                        defaultMessage: "Data center + server"
                                    })
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $da7b5b800f10f760$export$2e2bcd8739ae039 = $da7b5b800f10f760$var$EnterpriseSection;

});

parcelRegister("gTqUW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6eb266b4632978e1$export$2e2bcd8739ae039; });
/* get-the-most-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $NtjLk = parcelRequire("NtjLk");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $6eb266b4632978e1$var$pageSection = null;
const $6eb266b4632978e1$var$sectionCss = null;
const $6eb266b4632978e1$var$headerStyle = null;
const $6eb266b4632978e1$var$cardContainer = null;
const $6eb266b4632978e1$var$GetTheMostSection = ()=>{
    const intl = (0, $8e22h.default)();
    const cardData = [
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceHeaderText",
                defaultMessage: "Tailor to your team\u2019s needs"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.marketplaceBodyText",
                defaultMessage: "Extend your Atlassian products with thousands of apps from Marketplace."
            }),
            callToAction: {
                href: "https://marketplace.atlassian.com/",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.marketplacePrimaryLink",
                    defaultMessage: "Go to Marketplace"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:76e94ebd-d71e-4991-9008-7b2e838090c8/illustrations-spot-Integrations.svg?cdnVersion=2999"
        },
        {
            title: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityHeaderText",
                defaultMessage: "Train with Atlassian University"
            }),
            titleAs: "h3",
            body: intl.formatMessage({
                id: "TryPageTemplate.getTheMost.universityBodyText",
                defaultMessage: "Develop new skills, improve your team\u2019s work, and advance your professional career."
            }),
            callToAction: {
                href: "https://www.atlassian.com/university",
                text: intl.formatMessage({
                    id: "TryPageTemplate.getTheMost.universityPrimaryLink",
                    defaultMessage: "Go to Atlassian University"
                })
            },
            orientation: "horizontal",
            spotIllustrationUrl: "https://wac-cdn.atlassian.com/dam/jcr:a88ae3d8-e6fd-4428-8a14-c9ce6b460b0e/illustrations-spot-Atlassian%20Book_1.svg?cdnVersion=2999"
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1q51xy5q _85i5xncg _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_12l21wug _ahbq1wug _1ul91osq _11rm1hrf _bfhkcd5j _kqswh2mm"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _cg411tj6 _l5k1bfng _1pxq7vkz _ygm1idpf _u6q57vkz _sydsidpf _17z411ph _xztqidpf _ubikidpf _j8iydlk8 _h9g4idpf _1kll1ejb _1g9widpf _1kovidpf _bsriidpf _1qsfidpf _1x1pahaf _12adidpf _1xe1idpf _hcanidpf _nji3idpf _j269ahaf"
                        ]),
                        style: {
                            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "TryPageTemplate.getTheMost.header",
                                defaultMessage: "Get the most out of your products"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "6-6",
                    children: cardData.map((card, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1ui68ved"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), (0, $6Ppys._)({}, card))
                        }, index))
                })
            ]
        })
    });
};
var $6eb266b4632978e1$export$2e2bcd8739ae039 = $6eb266b4632978e1$var$GetTheMostSection;

});

parcelRegister("aUlfh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca30ac8f347471af$export$2e2bcd8739ae039; });
/* hero-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("kyJ5Y");
var $3DHNM = parcelRequire("3DHNM");
const $ca30ac8f347471af$var$HeroTryGraphCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.bodyText",
        defaultMessage: "Collaborate seamlessly across cross-functional teams, at scale"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:6f126124-1d52-4017-9078-40df4c78897e/illustrations-spot-Connections.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.graphCard.imgAltText",
        defaultMessage: "Connections illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$HeroTryLockCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.bodyText",
        defaultMessage: "Built with industry-leading privacy, security, and data control"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:c0c94526-036b-44df-9f0d-cd1e9455d1e2/illustrations-spot-Trust%20and%20Security.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.lockCard.imgAltText",
        defaultMessage: "Trust and security illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$HeroTryPuzzleCard = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.bodyText",
        defaultMessage: "Customize your products with 1,000+ apps and integrations"
    });
    const imgLink = "https://wac-cdn.atlassian.com/dam/jcr:3dfc6901-1535-48aa-a25a-870ee1d5ff8e/illustrations-spot-Integration%20Puzzle.svg?cdnVersion=1408";
    const imgAltText = intl.formatMessage({
        id: "TryPageTemplate.hero.puzzleCard.imgAltText",
        defaultMessage: "Integration puzzle illustration"
    });
    return {
        headerText: "",
        bodyText: headerText,
        imageAltText: imgAltText,
        imageLink: imgLink
    };
};
const $ca30ac8f347471af$var$sectionCssOverride = null;
const $ca30ac8f347471af$var$outerContainerCssOverride = null;
const $ca30ac8f347471af$var$HeroSection = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.hero.header",
        defaultMessage: "Try Atlassian apps for free"
    });
    const bodyText = intl.formatMessage({
        id: "TryPageTemplate.hero.bodyText",
        defaultMessage: "Our cloud products empower teams of all types, from startup to enterprise."
    });
    const backgroundProps = {
        bgColor: (0, $kbpa7.wacToken)("color.neutral.light100")
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_cg411tj6 _18oz1wto _1ap71k7u _u8fj1tcg _163midpf _yzu7idpf _1kll14b4 _1qdgidpf _7toc10nf _cjxodlk8 _a5ip1n2x _1f35m24h _ps1ee8xo _z0gn1h6o _p1061k92 _zqtwnl7k _130319ii _10vfidpf _1of01yg0 _1xw61h67 _sz6216xe _3int1gpt _dmb7grf3"
        ]),
        style: {
            "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900")),
            "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_16qs1cd0 _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3DHNM.ContentBlocksInline), {
                headerText: headerText,
                bodyText: bodyText,
                backgroundProperties: backgroundProps,
                inlineContentBlocks: [
                    $ca30ac8f347471af$var$HeroTryGraphCard(),
                    $ca30ac8f347471af$var$HeroTryLockCard(),
                    $ca30ac8f347471af$var$HeroTryPuzzleCard()
                ]
            })
        })
    });
};
var $ca30ac8f347471af$export$2e2bcd8739ae039 = $ca30ac8f347471af$var$HeroSection;

});
parcelRegister("kyJ5Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("3DHNM")).ContentBlocksInline; });

var $3DHNM = parcelRequire("3DHNM");

});
parcelRegister("3DHNM", function(module, exports) {
$parcel$export(module.exports, "ContentBlocksInline", function () { return $4d30ed72f33d6229$export$4fd59a663df2d810; });
/* content-blocks-inline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2tb46 = parcelRequire("2tb46");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");
const $4d30ed72f33d6229$var$getCardAspectRatio = (length)=>{
    switch(length){
        case 4:
            return "4/3";
        case 3:
            return "4/3";
        case 2:
            return "2/1";
        default:
            return "1/1";
    }
};
const $4d30ed72f33d6229$var$ctaStyle = null;
const $4d30ed72f33d6229$export$4fd59a663df2d810 = ({ headerText: headerText, bodyText: bodyText, backgroundProperties: backgroundProperties, className: className, eyebrowText: eyebrowText, iconName: iconName, linkPosition: linkPosition = "bottom", ctaProps: ctaProps, inlineContentBlocks: inlineContentBlocks })=>{
    if (inlineContentBlocks.length < 2 || inlineContentBlocks.length > 4) throw new Error("Pattern is meant to display between 2 and 4 cards");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.StyledBackground), (0, $edEzO._)((0, $6Ppys._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        iconName: iconName,
                        bodyText: bodyText,
                        isCentered: true,
                        ctaProps: linkPosition == "top" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? ctaProps : {}
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: inlineContentBlocks.map((block, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), (0, $6Ppys._)({
                            aspectRatio: $4d30ed72f33d6229$var$getCardAspectRatio(inlineContentBlocks.length)
                        }, block), index))
                }),
                linkPosition == "bottom" && (ctaProps === null || ctaProps === void 0 ? void 0 : ctaProps.primaryLinkProps) ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), (0, $6Ppys._)({}, ctaProps.primaryLinkProps))
                    })
                }) : null
            ]
        })
    }));
};

});



parcelRegister("eLUM2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eaa008ad72030cec$export$2e2bcd8739ae039; });
/* identity-and-security-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6Ppys = parcelRequire("6Ppys");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $5Dppx = parcelRequire("5Dppx");

var $lVutU = parcelRequire("lVutU");

var $8p9Sp = parcelRequire("8p9Sp");
const $eaa008ad72030cec$var$sectionStyles = null;
const $eaa008ad72030cec$var$IdentityAndSecuritySection = ()=>{
    const intl = (0, $8e22h.default)();
    const atlassianAccessHeaderText = intl.formatMessage({
        id: "TryPageTemplate.IdentityAndSecurity.title",
        defaultMessage: "Identity & Security"
    });
    const headerProps = {
        headerText: atlassianAccessHeaderText,
        dividerColor: (0, $kbpa7.wacToken)("color.primary.blue")
    };
    const atlassianAccessLink = "https://admin.atlassian.com/";
    const atlassianAccessBodyText = intl.formatMessage({
        id: "TryPageTemplate.identityAndSecurity.atlassianAccessBody",
        defaultMessage: "Gain company-wide visibility, security policies, and control across your Atlassian cloud infrastructure."
    });
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const guardLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    });
    const cardProps = {
        logo: guardLogo,
        link: atlassianAccessLink,
        bodyText: atlassianAccessBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
            name: "identityAndSecurity",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), (0, $6Ppys._)({}, headerProps))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), (0, $6Ppys._)({}, cardProps)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {})
                    ]
                })
            ]
        })
    });
};
var $eaa008ad72030cec$export$2e2bcd8739ae039 = $eaa008ad72030cec$var$IdentityAndSecuritySection;

});

parcelRegister("liucL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $79af9bea120adf60$export$2e2bcd8739ae039; });
/* plan-and-track.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $6Ppys = parcelRequire("6Ppys");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("k8C2X");
var $lVutU = parcelRequire("lVutU");
var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
const $79af9bea120adf60$var$sectionStyles = null;
const $79af9bea120adf60$var$PlanAndTrackSection = ()=>{
    const intl = (0, $8e22h.default)();
    const jiraSofttwareHeaderText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.title",
        defaultMessage: "Plan & Track"
    });
    const headerProps = {
        headerText: jiraSofttwareHeaderText,
        dividerColor: (0, $kbpa7.wacToken)("color.primary.blue")
    };
    const jiraSofttwareBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jiraBody",
        defaultMessage: "Friendly and intuitive collaboration for business teams and their projects, built for cross-team coordination and breaking down silos."
    });
    const jiraSofttwareLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const jirProductDiscoveryBodyText = intl.formatMessage({
        id: "TryPageTemplate.PlanAndTrack.jirProductDiscoveryBody",
        defaultMessage: "Organize and prioritize ideas, share product roadmaps, and connect business and tech teams, all in Jira."
    });
    const jirProductDiscoveryLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const tryCloud = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const jiraLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jira",
        type: "logo",
        appearance: "brand"
    });
    const jpdLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
    const jiracardProps = {
        logo: jiraLogo,
        link: jiraSofttwareLink,
        bodyText: jiraSofttwareBodyText,
        ctaText: tryCloud
    };
    const jpdcardProps = {
        logo: jpdLogo,
        link: jirProductDiscoveryLink,
        bodyText: jirProductDiscoveryBodyText,
        ctaText: tryCloud
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_ca0qvbgk _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), (0, $6Ppys._)({}, headerProps))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "6-6",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), (0, $6Ppys._)({}, jiracardProps)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), (0, $6Ppys._)({}, jpdcardProps))
                ]
            })
        ]
    });
};
var $79af9bea120adf60$export$2e2bcd8739ae039 = $79af9bea120adf60$var$PlanAndTrackSection;

});

parcelRegister("cBRR6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8d8fc6b8f8fde7c6$export$2e2bcd8739ae039; });
/* support-and-fix-try-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $lVutU = parcelRequire("lVutU");

var $5Dppx = parcelRequire("5Dppx");

var $8p9Sp = parcelRequire("8p9Sp");
/* Cards */ const $8d8fc6b8f8fde7c6$var$JsmCard = ()=>{
    const intl = (0, $8e22h.default)();
    const localizedLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-service-management");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.jsmCard.bodyText",
        defaultMessage: "Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast."
    });
    const localizedCtaText = intl.formatMessage((0, $8p9Sp.messages).tryCloud);
    const jsmLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
        logo: jsmLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $8d8fc6b8f8fde7c6$var$StatusCard = ()=>{
    const intl = (0, $8e22h.default)();
    const localizedLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=statuspage");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.statusCard.bodyText",
        defaultMessage: "Incidents happen. Keep your users informed with fewer support emails during downtime."
    });
    const localizedCtaText = intl.formatMessage({
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    });
    const statusPageLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "statuspage",
        type: "logo",
        appearance: "brand"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lVutU.TryPageCard), {
        logo: statusPageLogo,
        link: localizedLink,
        bodyText: localizedBodyText,
        ctaText: localizedCtaText
    });
};
const $8d8fc6b8f8fde7c6$var$sectionStyles = null;
const $8d8fc6b8f8fde7c6$var$SupportAndFixSection = ()=>{
    const intl = (0, $8e22h.default)();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.headerText",
        defaultMessage: "Support & fix"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "support-and-fix",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _kqswh2mm _s7n41q9y _12l21wug _ahbq1wug _1ul91osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Dppx.TryPageHeader), {
                        dividerColor: "#ff8b00",
                        headerText: headerText
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "6-6",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($8d8fc6b8f8fde7c6$var$JsmCard, {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($8d8fc6b8f8fde7c6$var$StatusCard, {})
                    ]
                })
            ]
        })
    });
};
var $8d8fc6b8f8fde7c6$export$2e2bcd8739ae039 = $8d8fc6b8f8fde7c6$var$SupportAndFixSection;

});




parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});


var $3NQOU = parcelRequire("3NQOU");

var $lfqXN = parcelRequire("lfqXN");
(0, $3NQOU.init)((0, $lfqXN.TryPage));


//# sourceMappingURL=try-page.3146da5d.js.map
